export var QueryClientType;
(function (QueryClientType) {
    /**
     *客户端类型--PC
     */
    QueryClientType["PC"] = "PC";
    /**
     * 客户端类型--MOBILE
     */
    QueryClientType["APP"] = "APP";
    /**
     * 客户端类型--OTHER
     */
    QueryClientType["OTHER"] = "OTHER";
})(QueryClientType || (QueryClientType = {}));
export var QueryDisplayType;
(function (QueryDisplayType) {
    /**
     * 默认展示查询列表配置的显示字段
     */
    QueryDisplayType["Default"] = "0";
    /**
     * 覆盖展示查询列表配置的显示字段
     */
    QueryDisplayType["Override"] = "1";
    /**
     * 在查询列表配置的显示字段的基础上新增显示字段
     */
    QueryDisplayType["Append"] = "2";
})(QueryDisplayType || (QueryDisplayType = {}));
/**
 * 导入结果代码
 */
export var ImportResult;
(function (ImportResult) {
    ImportResult[ImportResult["None"] = -1] = "None";
    ImportResult[ImportResult["Success"] = 0] = "Success";
    ImportResult[ImportResult["PartialSuccess"] = 1] = "PartialSuccess";
    ImportResult[ImportResult["FileTypeError"] = 2] = "FileTypeError";
    ImportResult[ImportResult["DataNumExceed"] = 3] = "DataNumExceed";
    ImportResult[ImportResult["DataColumnError"] = 4] = "DataColumnError";
    ImportResult[ImportResult["SystemError"] = 5] = "SystemError";
    ImportResult[ImportResult["Unspecified"] = 6] = "Unspecified";
    ImportResult[ImportResult["TemplateEmpty"] = 7] = "TemplateEmpty";
    ImportResult[ImportResult["FaileReImport"] = 8] = "FaileReImport";
})(ImportResult || (ImportResult = {}));
